/**
 * The deck a run begins with.
 *
 * A stage's own `startingDeck` is what you get playing it standalone from the
 * job sheet. A *run* ignores those and carries this one from stage to stage,
 * growing as you draft — which is the whole point of the meta-layer.
 *
 * It deliberately contains one answer to every hazard in `03-hazards.md` §2, so no
 * stage in the run is unwinnable on the deal alone. Drafting is then about
 * making a rig comfortably rather than about being allowed to play at all —
 * a roguelike where the shop can lock you out of a stage isn't difficult, it's
 * broken.
 *
 * Sixteen cards: big enough that a 5-card hand is a real sample, small enough
 * that adding or trimming one is felt immediately.
 */
export const STARTER_DECK: readonly string[] = [
  // Routing
  "card-pipe-glass",
  "card-pipe-glass",
  "card-pipe-hastelloy",

  // §2.1 thermal
  "card-cooling-jacket",
  "card-cooling-jacket",
  "card-cooling-jacket-twin",
  "card-flash-freeze",

  // §2.2 pressure
  "card-burst-disk",
  "card-surge-drum",
  "card-nitrogen-purge",

  // §2.3 corrosion
  "card-ptfe-lining",
  "card-patch-weld",

  // §2.4 poisoning
  "card-guard-bed",

  // §2.5 residence
  "card-solvent-flush",

  // Tempo
  "card-rush-order",
  "card-overtime",
];
